import { Box, IconButton, Typography,} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const OTReportsDetail = ({ selectedRow, handleClosePanel }) => {
  // console.log("selectedRow_value:", selectedRow);
  const project_datas =
    selectedRow?.pending_project_details?.pending_projects || [];
  if (!selectedRow) return null;
  return (
    <div className="p-4">
      <div className="row">
        <div className="col-12">
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography variant="h6">{selectedRow?.user_name}</Typography>
            <IconButton onClick={handleClosePanel}>
              <CloseIcon className="close_btn" />
            </IconButton>
          </Box>
        </div>
      </div>
      <div className="col-12 my-2">
        <div className=" total_pending d-flex align-items-center justify-content-between ">
          <p className="mb-0">Total Pending Hours</p>
          <p className="mb-0"> {selectedRow?.pending_hours}</p>
        </div>
      </div>
      <div className="col-12 my-2 mt-4">
        <div className="col-12 my-2 mt-4">
          <table className="custom-table">
            <thead>
              <tr>
                <th>Projects</th>
                <th>Hours</th>
              </tr>
            </thead>
            <tbody>
              {project_datas.length === 0 ? (
                <tr>
                  <td colSpan={2} className=" text-center p-4">
                    <Typography color="text.secondary">
                      No Data Found
                    </Typography>
                  </td>
                </tr>
              ) : (
                project_datas.map((list, index) => (
                  <tr key={index}>
                    <td>{list?.project_title}</td>
                    <td>{list?.total_hours}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
export default OTReportsDetail;
